module.exports = __webpack_public_path__ + "assets/table_chart.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/table_chart.svg
// module id = 764
// module chunks = 0